import { Component, OnInit } from '@angular/core';
import { PromoService } from './shared/promo.service';
import moment = require('moment');
import { PromoRequest } from '@builtbybros/al-model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-promos',
  templateUrl: 'promo.component.html',
  styleUrls: ['promo.component.scss']
})
export class PromoComponent implements OnInit {
  entity = 'promo';
  title = 'Promo';
  promos = {};
  promosReady = false;
  actions = true;
  prevPath = '/promo/';

  // [api param, column name, isSortable]
  columns = [
    ['name', 'Nombre', false],
    ['percentage', 'Porcentaje', false],
    ['fixed', 'Fijo', false],
    ['expirationDate', 'Válido hasta', false],
  ];

  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true]
  ];

  pagination = 100;
  offset = 0;

  hasDataTables = true;

  constructor(
    private promoService: PromoService,
    private router: Router,
    ) { }

  ngOnInit() {
    this.getAllPromos();
  }

  getAllPromos() {
    this.promoService.getAllPromos()
      .subscribe(
        promosResponse => {
          this.promos = promosResponse;
          // this.promos.expirationDate
          for (const u of this.promos['objects']) {
            u['expirationDate'] = moment(u['expirationDate']).format('DD/MM/YYYY');
            // const date = moment(promoResponse.expirationDate).format('MM/DD/YYYY');
          }
          this.promosReady = true;
        }
      );
  }

  delete(value) {
    this.promosReady = false;
    this.promoService.deletePromo(+value)
      .subscribe(
        updateResponse => {
          this.getAllPromos();
        }
      );
  }

  create() {
    const promo = new PromoRequest.Create();
    promo.parse({
      active: true,
      applyTo: 2,
      exclusive: true,
      expirationDate: '2023-08-22T03:00:00.000Z',
      name: 'Nombre Promoción ' + Math.floor(Math.random() * 1000),
      percentage: 30,
      roles: '2'
    });
    this.promoService.createPromo(promo)
      .subscribe(
        createResponse => {
          const url = '/promo/'+ createResponse.id +'/edit';
          this.router.navigate([url]);
        },
        error => {
          console.log({error})
          alert('Error al crear la promoción');
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/promos/promo.component.ts